import React from 'react';
import { useLocation } from 'react-router-dom';
import WhatsAppButton from './WhatsAppButton';

/**
 * Botão flutuante de WhatsApp foi removido do app a pedido do dono.
 * Mantemos o componente como no-op para não quebrar imports existentes.
 */
export default function ContextualWhatsApp() {
  return null;
}
